/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TecnicoDTO } from './TecnicoDTO';
import {
    TecnicoDTOFromJSON,
    TecnicoDTOFromJSONTyped,
    TecnicoDTOToJSON,
} from './TecnicoDTO';
import type { TipoAnimaleDTO } from './TipoAnimaleDTO';
import {
    TipoAnimaleDTOFromJSON,
    TipoAnimaleDTOFromJSONTyped,
    TipoAnimaleDTOToJSON,
} from './TipoAnimaleDTO';
import type { TipoTrattamentoDTO } from './TipoTrattamentoDTO';
import {
    TipoTrattamentoDTOFromJSON,
    TipoTrattamentoDTOFromJSONTyped,
    TipoTrattamentoDTOToJSON,
} from './TipoTrattamentoDTO';

/**
 * 
 * @export
 * @interface MovimentoTrattamentoDTO
 */
export interface MovimentoTrattamentoDTO {
    /**
     * 
     * @type {number}
     * @memberof MovimentoTrattamentoDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof MovimentoTrattamentoDTO
     */
    idDocumento?: number;
    /**
     * 
     * @type {number}
     * @memberof MovimentoTrattamentoDTO
     */
    quantita?: number;
    /**
     * 
     * @type {string}
     * @memberof MovimentoTrattamentoDTO
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoTrattamentoDTO
     */
    valoreFixed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoTrattamentoDTO
     */
    idCapannone?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoTrattamentoDTO
     */
    idTipoAnimale?: number;
    /**
     * 
     * @type {number}
     * @memberof MovimentoTrattamentoDTO
     */
    idTipoTrattamento?: number;
    /**
     * 
     * @type {number}
     * @memberof MovimentoTrattamentoDTO
     */
    idTecnico?: number;
    /**
     * 
     * @type {number}
     * @memberof MovimentoTrattamentoDTO
     */
    valore?: number;
    /**
     * 
     * @type {Date}
     * @memberof MovimentoTrattamentoDTO
     */
    dataInizio?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MovimentoTrattamentoDTO
     */
    dataFine?: Date;
    /**
     * 
     * @type {TipoAnimaleDTO}
     * @memberof MovimentoTrattamentoDTO
     */
    tipoAnimale?: TipoAnimaleDTO;
    /**
     * 
     * @type {TipoTrattamentoDTO}
     * @memberof MovimentoTrattamentoDTO
     */
    tipoTrattamento?: TipoTrattamentoDTO;
    /**
     * 
     * @type {TecnicoDTO}
     * @memberof MovimentoTrattamentoDTO
     */
    tecnico?: TecnicoDTO;
}

/**
 * Check if a given object implements the MovimentoTrattamentoDTO interface.
 */
export function instanceOfMovimentoTrattamentoDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MovimentoTrattamentoDTOFromJSON(json: any): MovimentoTrattamentoDTO {
    return MovimentoTrattamentoDTOFromJSONTyped(json, false);
}

export function MovimentoTrattamentoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MovimentoTrattamentoDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'idDocumento': !exists(json, 'idDocumento') ? undefined : json['idDocumento'],
        'quantita': !exists(json, 'quantita') ? undefined : json['quantita'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'valoreFixed': !exists(json, 'valoreFixed') ? undefined : json['valoreFixed'],
        'idCapannone': !exists(json, 'idCapannone') ? undefined : json['idCapannone'],
        'idTipoAnimale': !exists(json, 'idTipoAnimale') ? undefined : json['idTipoAnimale'],
        'idTipoTrattamento': !exists(json, 'idTipoTrattamento') ? undefined : json['idTipoTrattamento'],
        'idTecnico': !exists(json, 'idTecnico') ? undefined : json['idTecnico'],
        'valore': !exists(json, 'valore') ? undefined : json['valore'],
        'dataInizio': !exists(json, 'dataInizio') ? undefined : (new Date(json['dataInizio'])),
        'dataFine': !exists(json, 'dataFine') ? undefined : (new Date(json['dataFine'])),
        'tipoAnimale': !exists(json, 'tipoAnimale') ? undefined : TipoAnimaleDTOFromJSON(json['tipoAnimale']),
        'tipoTrattamento': !exists(json, 'tipoTrattamento') ? undefined : TipoTrattamentoDTOFromJSON(json['tipoTrattamento']),
        'tecnico': !exists(json, 'tecnico') ? undefined : TecnicoDTOFromJSON(json['tecnico']),
    };
}

export function MovimentoTrattamentoDTOToJSON(value?: MovimentoTrattamentoDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'idDocumento': value.idDocumento,
        'quantita': value.quantita,
        'note': value.note,
        'valoreFixed': value.valoreFixed,
        'idCapannone': value.idCapannone,
        'idTipoAnimale': value.idTipoAnimale,
        'idTipoTrattamento': value.idTipoTrattamento,
        'idTecnico': value.idTecnico,
        'valore': value.valore,
        'dataInizio': value.dataInizio === undefined ? undefined : (value.dataInizio.toISOString()),
        'dataFine': value.dataFine === undefined ? undefined : (value.dataFine.toISOString()),
        'tipoAnimale': TipoAnimaleDTOToJSON(value.tipoAnimale),
        'tipoTrattamento': TipoTrattamentoDTOToJSON(value.tipoTrattamento),
        'tecnico': TecnicoDTOToJSON(value.tecnico),
    };
}

